import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

//slice
import { fetchIndividualOfferCode } from "../../../../Redux/Slices/contentManagementSlice";

const ViewOfferCode = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [offerCodeData, setOfferCodeData] = useState(null);

  useEffect(() => {
    dispatch(
      fetchIndividualOfferCode({
        data: {
          id: id,
        },
        callBack: fetchOfferCodeCB,
      })
    );
  }, [id]);

  const fetchOfferCodeCB = (data) => {
    console.log(data.result);
    setOfferCodeData(data.result);
  };

  return (
    <MainLayout pageName={"Content Management"}>
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Offer Codes</p>
      </div>
      <div className="offerCode-profile-details">
        <div className="view-offerCode-container-header">
          <h2>View Offer Code Details</h2>
        </div>

        <hr style={{ backgroundColor: "#E6E6E6" }} />

        <div className="offerCode-details-container">
          {offerCodeData ? (
            <>
              <div className="offerCode-details-item">
                <div className="objKey">Offer Code</div>
                <div>: {offerCodeData.offer_code ?? "Not Captured"}</div>
              </div>
              <div className="offerCode-details-item">
                <div className="objKey">No of Credits Available</div>
                <div>
                  :{" "}
                  {offerCodeData.number_of_credits_available ?? "Not Captured"}
                </div>
              </div>
              <div className="offerCode-details-item">
                <div className="objKey">Start Date</div>
                <div>
                  :{" "}
                  {new Date(offerCodeData.start_date).toLocaleDateString(
                    "en-GB"
                  ) ?? "Not Captured"}
                </div>
              </div>
              <div className="offerCode-details-item">
                <div className="objKey">End Date</div>
                <div>
                  :{" "}
                  {new Date(offerCodeData.end_date).toLocaleDateString(
                    "en-GB"
                  ) ?? "Not Captured"}
                </div>
              </div>
              <div className="offerCode-details-item">
                <div className="objKey">Notes</div>
                <div>: {offerCodeData.notes ?? "Not Captured"}</div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewOfferCode;
